<!-- 模板的弹出框 -->
<template>
  <div class="PopupBox">
    <div
      :class="[
        'createBooking',
        {
          createBookingRight: !FrameProperty.aleft,
          createBookingBottom: !FrameProperty.upward,
          createBookingRightBottom:
            !FrameProperty.aleft && !FrameProperty.upward,
        },
      ]"
      :style="{
        top: FrameProperty.top + 'px',
        left: FrameProperty.left + 'px',
      }">
      <!-- 头部标题 -->
      <div class="EventWrapTitle">
        <div
          v-if="EventMotionSelect == 0"
          class="EventTopTitle">
          <p
            class="event_color"
            :style="{ background: eventDetail.color }"></p>
          <p class="Event_title">{{ eventDetail.title }}</p>
        </div>
        <ul
          class="CompileTitle"
          v-else>
          <li
            @click="CutTab('note')"
            :class="{ active: CompileType === 'note' }">
            {{ $t('lang.note') }}
          </li>
          <li class="separator">|</li>
          <li
            @click="CutTab('events')"
            :class="{ active: CompileType === 'events' }">
            {{ $t('lang.Events')}}
          </li>
          <li class="separator">|</li>
          <li
            @click="CutTab('device')"
            :class="{ active: CompileType === 'device' }">
            {{ $t('lang.device') }}
          </li>
        </ul>
        <div
          class="iconfont closeCreateBox"
          @click="closeCreateBox">
          <i class="iconfont icon-a-closethick"></i>
        </div>
      </div>
      <!-- 视频的详情 -->
      <div
        class="EventDetail"
        v-if="EventMotionSelect == 0">
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.time') }}</p>
          <p class="detailRight">
            {{ displayTime(eventDetail.startTime, eventDetail.endTime) }}
          </p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.reporter') }}</p>
          <p class="detailRight">{{ eventDetail.reporter }}</p>
        </div>
        <div class="detail_item storySlug">
          <p class="detailLeft">{{ $t('lang.storySlug') }}</p>
          <p class="detailRight">{{ eventDetail.description }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.source') }}</p>
          <p class="detailRight">{{ eventDetail.tname }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.bookingChannel') }}</p>
          <p class="detailRight">{{ eventDetail.rname }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{$t('lang.SecondaryRecord')}}</p>
          <p class="detailRight">
            {{ eventDetail.record == 1 ? 'Enable' : 'Disable' }}
          </p>
        </div>
        <div
          class="eventsDetail"
          v-if="subeventSwitch">
          <div
            class="detail_item"
            :class="{ detailbottom: subeventSwitch == 2 }">
            <p class="detailLeft">{{$t('lang.Events')}}</p>
            <p
              class="detailRight"
              @click="
                subeventSwitch == 1
                  ? (subeventSwitch = 2)
                  : (subeventSwitch = 1)
              ">
              <i
                class="el-icon-arrow-down"
                v-if="subeventSwitch == 1"></i>
              <i
                class="el-icon-arrow-up"
                v-else></i>
            </p>
          </div>
          <div
            class="eventsListWrap"
            v-if="subeventSwitch == 2">
            <div
              class="eventsBox"
              v-for="item in subeventList"
              :key="item.id">
              <div class="title">{{ SetSubeventName(item) }}</div>
              <div class="time">
                {{ displayTime(item.timingIn, item.timingOut, 1) }}
              </div>
              <div class="duration">
                {{ calculateInterval(item.accumulatedProgramTiming) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 创建与修改事件 -->
      <div
        class="EventUpdateandCreate"
        :id="`${(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4) ? 'EventUpdateandCreate' : ''}`"
        v-else>
        <!-- note部分 -->
        <div
          class="note"
          v-if="CompileType === 'note'">
          <div class="c_item">
            <input
              type="text"
              v-model="eventDetail.title"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              :placeholder="$t('lang.createTitle')" />
            <div
              class="color_box"
              @click="mostSwitch.ColorShow = !mostSwitch.ColorShow">
              <div :class="['color', ColorTransition(eventDetail.color)]"></div>
              <i :class="['el-icon-caret-bottom', { top: mostSwitch.ColorShow }]"></i>
              <div
                class="color_opt"
                v-if="mostSwitch.ColorShow">
                <span>{{ $t('lang.color') }}</span>
                <ul>
                  <li
                    v-for="(item, index) in colorArr"
                    :key="index"
                    :class="[item.name]"
                    @click.stop="chooseColor(item)"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="DuplicateHint" v-if="IsCopyEvent">
            {{$t('lang.Duplicate')}}
          </div>
          <div class="c_item timeSelete">
            <div class="time_opt">
              <el-time-picker
                v-model="eventDetail.startTime"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                :format="PickerFormat.Time"
                @change="changeStartTime"
              >
              </el-time-picker>
            </div>
            <div class="to">-</div>
            <div class="time_opt">
              <el-time-picker
                v-model="eventDetail.endTime"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                :format="PickerFormat.Time"
                @change="changeEndTime"
              >
              </el-time-picker>
            </div>
          </div>
          <!-- <div class="c_item">
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.reporter')"
              v-model="eventDetail.reporter" />
          </div> -->
          <div class="c_item HouseID">
            <p class="HouseIDKey">{{$t('lang.HouseId')}}</p>
            <p class="HouseIDVaule">
              <input
              type="text"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.houseId"
              placeholder="House ID" />
            </p>
          </div>
          <!-- <div class="c_item RecordSelete">
            <el-checkbox
              v-model="eventDetail.record">{{ $t('lang.SecondaryRecord') }}</el-checkbox>
          </div> -->
          <div class="c_item des">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              style="height:60px;resize:none"
              maxlength="255"
              :placeholder="$t('lang.des')"
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              v-model="eventDetail.description"></textarea>
              <span class="desNum" >{{  getLength(eventDetail.description) }}</span>
          </div>
        </div>
        <!-- events部分 -->
        <div
          class="EventsWrap"
          v-else-if="CompileType === 'events'">
          <div class="ReferenceMedia">
            <div class="MediaType">
              <el-select
                v-model="eventDetail.sourceType"
                @change="SourceTypeChange"
                placeholder="Source type">
                <el-option
                  v-for="(item, index) in ['Media', 'Live']"
                  :key="index"
                  :label="item"
                  :value="index">
                </el-option>
              </el-select>
            </div>
            <div class="MediaSelect">
              <public-file-select
                v-if="!eventDetail.sourceType"
                :SelectType="1"
                :searchType='0'
                :SelectValue="{
                  fileId: eventDetail.fileId,
                  fileName: eventDetail.tname,
                }"
                :AppendBody="false"
                @fileSelectChange="
                  pitchOnFile => fileSeleteChange(pitchOnFile, 1)
                "></public-file-select>
              <el-select
                v-else
                v-model="eventDetail.tpeerid"
                :popper-append-to-body="false"
                v-scroll="SourcebindScroll"
                filterable
                :filter-method="SearchSource"
                :placeholder="$t('lang.select')"
                @change="SelectSource">
                <el-option
                  v-for="item in SourceList"
                  :key="item.peerId"
                  :label="item.name"
                  :value="item.peerId">
                </el-option>
              </el-select>
            </div>
            <div class="MediaTiming">
              <el-select v-model="eventDetail.timingId" @change="changeTimingFile" :placeholder="$t('lang.timing')" v-scroll="bindScroll" :popper-append-to-body="false" filterable :filter-method="searchFile">
                <el-option v-for="item in mcpTimingList" :key="item.id" :label="item.name" :value="item.id">
                  <span class="timing-item ellipsis" :title="item.name">{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="Thumbnails">
              <input
              @input="PushUndo('input')"
              @change="PushUndo('inputEnd')"
              type="text"
              v-model="eventDetail.thumbnail"
              :placeholder="$t('lang.ThumbnailURL')" />
            </div>
          </div>
          <div class="EventsTitle">
            <div class="MediaIndex"></div>
            <div class="Title-item"></div>
            <div class="Title-item">{{ $t('lang.Event') }}</div>
            <div class="Title-item">{{ $t('lang.File') }}</div>
            <div class="Title-item">{{ $t('lang.TimingIn') }}</div>
            <div class="Title-item">{{ $t('lang.TimingOut') }}</div>
            <div class="Title-item Duration">{{ $t('lang.duration') }}</div>
          </div>
          <div class="EventsListWrap">
            <div v-for="(subevent, index) in subeventList"
              :key="index">
            <div
              class="EventsList"
              >
              <div class="MediaIndex">
                <span v-if="subevent.segmentId == 1">{{ subevent.SerialNumber }}</span>
              </div>
              <!-- Segments -->
              <div class="Title-item">
                <div class="GxtScte fileSelete" v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0||(subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1)))">
                  <el-select
                    v-model="subevent.segmentId"
                    :popper-append-to-body="false"
                    :placeholder="$t('lang.select')"
                    :disabled="UnderplayClipList[subevent.blockId] > 1"

                    @change="SegmentsChang(subevent,index)">
                    <el-option
                      :title="$t(`lang.${item.label}`)"
                      v-for="item in SegmentsType"
                      :key="item.value"
                      :label="$t(`lang.${item.label}`)"
                      v-show="item.isShow"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- Event -->
              <div class="Title-item">
                <div
                  class="GxtScte"
                  v-if="!((subevent.segmentId == 2 || subevent.segmentId == 11||subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block' && subevent.UnderplayClip == 0)">
                  <!-- scte -->
                  <el-select
                    v-if="subevent.segmentId == 2 || subevent.segmentId == 11"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    :popper-append-to-body="false"
                    @change="PushUndo"
                    >
                    <el-option
                      v-for="item in ScteSpliceType"
                      :key="item.value"
                      :label="$t(`lang.${item.label}`)"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- GFX -->
                  <el-select
                    v-if="subevent.segmentId == 3"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="PushUndo"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType != 'Flowics'&&subevent.eventOperationType != 'Singular'"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type != 1"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="subevent.segmentId == 13&&subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type != 1"
                    v-model="subevent.eventOperationType"
                    :placeholder="$t('lang.select')"
                    @change="changeSegment(subevent)"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                   <div class="logoAndHashText"  v-if="subevent.segmentId == 13&&subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1">{{subevent.iframeInfoParams.title}}</div>
                   <div class="logoAndHashText"  v-if="subevent.segmentId == 13&&subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1">{{subevent.singularInfoParams.payloadKey}}</div>
                </div>
              </div>
              <!-- File -->
              <div class="Title-item">
                <div class="referenceName" v-if="subevent.segmentId==1">
                  {{subevent.fileName?subevent.fileName:eventDetail.tname}}
                </div>
                <div
                  class="GxtScte fileSelete"
                  v-if="
                    ((subevent.segmentId == 2 || subevent.segmentId == 11) &&
                      subevent.eventOperationType == 'Underplay clip') ||
                      subevent.segmentId == 4 ||
                      subevent.segmentId == 5 ||
                      subevent.segmentId == 10||
                      subevent.segmentId == 15
                  ">
                  <public-file-select
                   v-if="subevent.segmentId!=15"
                    :searchType='0'
                    :SelectType="1"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :AppendBody="false"
                    @fileSelectChange="
                      pitchOnFile => fileSeleteChange(pitchOnFile, subevent, index)
                    "></public-file-select>
                    <public-multiple-select
                    v-if="LiveParams && subevent.segmentId==15"
                    :SelectType="2"
                    :configParams="subevent.segmentId==15?LiveParams:MediaParams"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :SearchTypeList="subevent.segmentId==15?[true,false,false]:[false, true, true]"
                    :otherParam="{placeholder: 'select', hierarchy: subeventList.length - index}"
                    @MediaLiveSelectChange="pitchOnFile => SubeventFileDispose(pitchOnFile, subevent, index)"
                    @clearMessage="SubeventClearMessage(subevent)"
                  >
                </public-multiple-select>
                </div>
                <div class="fileSelete" v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'">
                  <logo-crawl-select
                  :class="subevent.showColor?'showRed':''"
                  v-if="subevent.eventOperationType != 'Flowics'&&subevent.eventOperationType != 'Singular'"
                    :SelectValue="{
                      fileId: subevent.fileIdd,
                      fileName: subevent.fileName,
                    }"
                    :FileSelectList="subevent.eventOperationType == 'Crawl' ? getCrawlList : showThumbList"
                    :AppendBody="false"
                    @fileSelectChange="
                      pitchOnFile => LogoCrawlChange(pitchOnFile, subevent)
                    "></logo-crawl-select>
                    <div v-if="subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type != 1">
                      <el-select
                      :class="subevent.showColor?'showRed':''"
                        v-model="subevent.singularInfoParams.subCompositionName"
                        :placeholder="$t('lang.select')"
                        @change="singularSelect(subevent,index)"
                        @focus="getSingularInfo"
                        :popper-append-to-body="false">
                        <el-option
                          v-for="item in singularSelectList"
                          :key="item.subCompositionId"
                          :label="item.subCompositionName"
                          :value="item.subCompositionName"
                          >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="flowicsContent" v-if="subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type != 1&&SingularMessage.flowicsToken" :class="subevent.showColor?'showRed':''">
                      <flowics-select  class="flowicsSelect" :SingularMessage='SingularMessage'  :selectIdParam='subevent.iframeInfoParams' @FlowicsParamSelect='logoAndHashText=>FlowicsParamSelect(logoAndHashText,subevent,index)'></flowics-select>
                      <!-- <div class="flowicsAdd">
                        <i
                          class="iconfont icon-add"
                          @click="addFlowics(subevent,index)"></i>
                      </div> -->
                    </div>
                    <div class="logoAndHashValue" :title="subevent.iframeInfoParams.value" v-if="subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type == 1"><el-input v-model="subevent.iframeInfoParams.value"></el-input></div>
                    <div class="logoAndHashValue" :title="subevent.singularInfoParams.payloadValue" v-if="subevent.eventOperationType=='Singular'&&subevent.singularInfoParams.type == 1"><el-input v-model="subevent.singularInfoParams.payloadValue"></el-input></div>
                </div>
                <div class="SinglaType" v-if="subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE'">
                  <!-- singla -->
                  <el-select
                  :class="subevent.showColor?'showRed':''"
                    v-model="subevent.fileIdd"
                    :placeholder="$t('lang.select')"
                    @change="PushUndo"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in SubeventTypeSelete.TimeSignalList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                </div>
                <div
                  class="noSelete"
                  v-else></div>
              </div>
              <!-- Timing-In -->
              <div class="Title-item timePicker">
                <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetIn', index)" v-if="subevent.segmentId == 13&&(((subevent.iframeInfoParams&&subevent.iframeInfoParams.type != 1)||subevent.eventOperationType!='Flowics')&&((subevent.singularInfoParams&&subevent.singularInfoParams.type != 1)||subevent.eventOperationType!='Singular'))">{{formatSeconds(subevent.OffsetIn)}}</div>
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-show="!((subevent.segmentId == 13&&subevent.eventOperationType == 'Flowics'&& subevent.iframeInfoParams.type == 1)||(subevent.segmentId == 13&&subevent.eventOperationType == 'Singular'&& subevent.singularInfoParams.type == 1))"
                  ref="SecondaryOffsetIn"
                  v-model="subevent.ShowTimingIn"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  :disabled="subevent.segmentId == 12"
                  @blur="DateChange(subevent, 'In', index)">
                </el-time-picker>
              </div>
              <!-- Timing-Out -->
              <div class="Title-item timePicker">
                <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetOut', index)" v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'&&((subevent.iframeInfoParams&&subevent.iframeInfoParams.type != 1)||subevent.eventOperationType!='Flowics')&&((subevent.singularInfoParams&&subevent.singularInfoParams.type != 1)||subevent.eventOperationType!='Singular')">{{formatSeconds(subevent.OffsetOut)}}</div>
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-show="!(subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE')&&!(subevent.eventOperationType == 'Flowics'&&subevent.iframeInfoParams.type == 1)&&!(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)"
                  ref="SecondaryOffsetOut"
                  v-model="subevent.ShowTimingOut"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  :disabled="subevent.segmentId == 12"
                  @blur="DateChange(subevent, 'Out', index)">
                </el-time-picker>
              </div>
              <!-- <div class="Title-item timePicker">
                <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetOut', index)" v-if="subevent.segmentId == 13 && subevent.eventOperationType != 'SCTE'&&((subevent.iframeInfoParams&&subevent.iframeInfoParams.type != 1)||subevent.eventOperationType!='Flowics')&&((subevent.singularInfoParams&&subevent.singularInfoParams.type != 1)||subevent.eventOperationType!='Singular')">{{formatSeconds(subevent.OffsetOut)}}</div>
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-model="subevent.ShowTimingIn"
                  :picker-options="{
                    selectableRange: subeventDateLimit,
                  }"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  @blur="DateChange(subevent, index)">
                </el-time-picker>
              </div>

              <div class="Title-item timePicker">
                <el-time-picker
                  v-if="!IsHoldEvents"
                  v-model="subevent.ShowTimingOut"
                  :picker-options="{
                    selectableRange: subeventDateLimit,
                  }"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  :format="PickerFormat.Time"
                  @blur="DateChange(subevent, index)">
                </el-time-picker>
              </div> -->
              <!-- Duration -->
              <div class="Title-item Duration-item">
                <div class="Duration" v-if="!((subevent.segmentId == 13 && subevent.eventOperationType == 'SCTE') || (IsHoldEvents && subevent.segmentId == 1)||(subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics'&&subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)))" @click="DurationEditShow(index)">
                  {{ calculateInterval(subevent.accumulatedProgramTiming) }}
                </div>
                <duration-edit v-if="subevent.durationEdit" :SonEventDuration="subevent.accumulatedProgramTiming" @EditEnd="(value) => DurationEditEnd(value, subevent, index)"></duration-edit>
              </div>
              <!-- 删除操作 -->
              <div class="delete-item">
                <div
                  v-if="!(subevent.segmentId == 13 && ((subevent.eventOperationType=='Flowics'&&subevent.iframeInfoParams.type == 1)||(subevent.eventOperationType == 'Singular'&&subevent.singularInfoParams.type == 1)))"
                  class="delete"
                  @click="deleteSubevent(subevent, index)">
                  <i class="iconfont icon-icon14"></i>
                </div>
              </div>
            </div>
            </div>
            <div class="addSubevent">
              <i
                class="iconfont icon-add"
                @click="addSubevent('end')"></i>
            </div>
          </div>
        </div>
        <!-- device部分 -->
        <div
          class="device"
          v-else>
          <div class="d_item">
            <span>{{ $t('lang.delay') }}{{ Rversions ? '(0.3-50s)' : '(0.5-50s)' }}</span>
            <input
              type="text"
              :class="['input', { delay: mostSwitch.editDelay }]"
              v-model="eventDetail.delay"
              @focus="mostSwitch.editDelay = true"
              @blur="DelayBitChange('editDelay')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
          <div class="d_item">
            <span>{{ $t('lang.bit') }}(100-10240Kbps)</span>
            <input
              type="text"
              :class="['input', { bitrate: mostSwitch.editBit }]"
              v-model="eventDetail.bitrate"
              @focus="mostSwitch.editBit = true"
              @blur="DelayBitChange('editBit')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
        </div>
      </div>

      <!-- 底下的操作 -->
      <div class="create_footer">
        <div
          class="DetailButton"
          v-show="EventMotionSelect == 1">
          <button
            class="delete"
            v-if="!(eventDetail.liveStatus == 2)"
            @click="DeleteEvent">
            {{ $t('lang.delete') }}
          </button>
          <button
            class="copy"
            :style="{'margin-right':(eventDetail.liveStatus == 2) ? '50px': ''}"
            @click="copyEvent">
            {{ $t('lang.copy') }}
          </button>
          <!-- <button class="edit" @click="EventMotionSelect = 1">
            {{ $t("lang.edit") }}
          </button> -->
        </div>
        <div
          class="ComplieButton"
          v-show="EventMotionSelect != 0">
          <button
            class="cancel"
            @click="closeCreateBox">
            {{ $t('lang.cancel') }}
          </button>
          <button
            class="save f_right"
            v-show="EventMotionSelect == 1 && !(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4)"
            @click="SaveEvent(1)">
            {{ $t('lang.save') }}
          </button>
          <button
            class="save"
            v-show="EventMotionSelect == 2"
            @click="SaveEvent(0)">
            {{ $t('lang.create') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapState } from 'vuex'
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import {
  Segments,
  LogoConfig,
  ScteType,
  UnderplayType,
  SourceConfigParams
} from '@/assets/js/temConfig.js'
import { EventColorArr } from '@/assets/js/common/ParamConfig.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
import LogoCrawlSelect from '@/components/file/LogoCrawlSelect.vue'
import FlowicsSelect from '@/components/common/FlowicsSelect.vue'
const googleKey = 'playout'
export default {
  props: {
    // 选中的事件
    picthOnEvent: {
      type: Object,
      default: () => ({
        //   新加子事件scte属性
        eventSegments: []
      })
    },
    // 对事件的几种操作
    EventMotion: {
      type: [String, Number],
      default: 1
    }, // 0 展示 1编辑 2创建
    // R的信息
    fixedDevice: Object,
    // 鼠标所点位置
    BoxPosition: {
      type: Object,
      default: () => ({
        top: 500,
        left: 500
      })
    },
    // 设置中的信息
    SettingMessage: {
      type: Object,
      default: () => {}
    },
    // 撤回的消息
    PreviousAction: {
      type: Object,
      default: () => {}
    },
    // 撤回方法实例
    UndoActionPro: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // 当天开始时间时间戳
      timeDifference: 0,
      // 视频时间
      videoTimes: 0,
      // R的版本大于7.6
      Rversions: false,
      // 对事件的几种操作
      EventMotionSelect: 0,
      // 是否copy
      IsCopyEvent: false,
      // 弹出框的一些属性
      FrameProperty: {
        left: 100,
        top: 200
      },
      // 所有事件时间
      AllEventTime: {
        EventStarttime: 0, // 上一次主事件开始时间
        EventTime: 0, // 主事件时间
        VideoTime: 0, // 主视频时间
        SubeventTime: 0 // 子事件时间
      },
      // 事件的详细信息
      eventDetail: {
        record: false,
        sourceType: 0
      },
      //  是note还是device
      CompileType: 'note',
      // 一系列开关
      mostSwitch: {
        // 颜色开关
        ColorShow: false,
        // 选择Source
        BoxSourceList: false,
        // 编辑Delay 延时时间
        editDelay: false,
        // 编辑bit率
        editBit: false,
        // 是否正在执行
        IsProgress: false
      },
      // Features相关控制
      FeaturesList: {
        HoldEventsRundownTemplate: false
      },
      //   颜色选项
      colorArr: EventColorArr,
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        pageNum: 0,
        pageSize: 35,
        condition: '',
        programId: '',
        loadEnd: false
      },
      // source滚动加载
      SourcebindScroll: {
        onScroll: this.getSourceList,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      //   子事件是否显示
      subeventSwitch: 1, // 0不显示  1显示但不显示列表 2显示列表
      SubeventTypeSelete: {
        // 初始配置文件，TODO:改为从initConfig中获取
        segments: Segments,
        scteType: ScteType,
        logoConfig: LogoConfig,
        underplayType: UnderplayType,
        TimeSignalList: []
      },
      // segments类型
      SegmentsType: [
        {
          value: 6,
          key: 'SCTE Program Start',
          label: 'SCTEProgramStart',
          isShow: true
        },
        {
          value: 1,
          key: 'Reference Media',
          label: 'ReferenceMedia',
          isShow: true
        },
        {
          value: 2,
          key: 'SCTE(Splice)',
          label: 'SCTESplice',
          isShow: true
        },
        {
          value: 11,
          key: 'SCTE (Time Signal Auto Stop)',
          label: 'TimeSignalAuto',
          isShow: true
        },
        {
          value: 4,
          key: 'Underplay',
          label: 'Underplay',
          isShow: true
        },
        {
          value: 15,
          key: 'Live',
          label: 'Live',
          isShow: true
        },
        {
          value: 5,
          key: 'Promo',
          label: 'Promo',
          isShow: true
        },
        {
          value: 10,
          key: 'Media',
          label: 'Media',
          isShow: true
        },
        {
          value: 9,
          key: 'Black',
          label: 'Black',
          isShow: true
        },
        {
          value: 13,
          key: 'Secondary',
          label: 'Secondary',
          isShow: true
        },
        {
          value: 7,
          key: 'SCTE Program End',
          label: 'SCTEProgramEnd',
          isShow: true
        }
      ],
      // ScteSplice类型
      ScteSpliceType: [
        {
          value: 'Scte only',
          label: 'SCTEonly',
          file: false,
          In: false,
          Out: false
        },
        {
          value: 'Underplay clip',
          label: 'UnderplayClip',
          file: false,
          In: false,
          Out: false
        }
      ],
      // logo类型
      logoConfig: LogoConfig,
      // subevent列表
      subeventList: [],
      // 编辑时删除的子事件
      DeleteSubeventList: [],
      //   子事件选择限制
      subeventDateLimit: '00:00:00 - 23:01:00',
      // timing文件选择
      bindScroll: {
        loading: false,
        noMore: false,
        onScroll: this.getNextPage,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      // 文件滚动加载
      McpObj: {
        pageNum: 1,
        pageSize: 10,
        condition: ''
      },
      // timming文件存的文件夹
      FolderObjectKey: '',
      // timing列表
      mcpTimingList: [],
      // scte时间间隔
      ScteDuration: 90,
      pageMark: '',
      // region信息
      RegionInfo: {},
      // 时间选择格式
      PickerFormat: {
        Date: 'yyyy-MM-dd',
        Time: 'h:mm:ss A',
        DateTime: 'yyyy-MM-dd h:mm:ss A'
      },
      UndoKey: ['CompileType', 'IsCopyEvent', 'EventMotionSelect', 'eventDetail', 'subeventList'],
      // 是否HoldEvent模式事件
      IsHoldEvents: false,
      SingularMessage: {
        flowicsToken: ''
      },
      // crawl列表
      getCrawlList: [],
      // 缩略图列表
      showThumbList: [],
      // UnderplayClip scte一组数量
      UnderplayClipList: {},
      // singular  file
      singularSelectList: [],
      numTimes: 0,
      // PGMSCTE的信息展示
      PGMScteMessage: {
        PGMTotalTime: '',
        ScteTotalTime: '',
        ScteNumber: 0
      },
      // live选择配置
      LiveParams: ''
    }
  },
  components: {
    PublicFileSelect,
    LogoCrawlSelect,
    FlowicsSelect,
    PublicMultipleSelect
  },
  computed: mapState({
    State: (state) => state,
    listFeatures: (state) => state.playout.listFeatures
  }),
  watch: {
    // 监听子事件变化
    subeventList () {
    },
    // 监听r变化
    fixedDevice () {
      this.closeCreateBox()
    },
    // 监听tab变化
    CompileType (item) {
      if (item == 'events') {
        if (!this.ScteDuration) {
          this.getScteDuration()
        }
        commonRequest.showThumbList().then((res) => {
          this.showThumbList = res
        })
      }
    },
    PreviousAction: {
      handler () {
        this.$nextTick(() => {
          if (this.PreviousAction) this.Undo(this.PreviousAction)
        })
      },
      immediate: true
    },
    // 监听pgmEnd开关
    listFeatures: {
      handler (val) {
        Object.keys(this.FeaturesList).forEach((key) => {
          if (val.includes(key)) {
            this.FeaturesList[key] = true
          } else {
            this.FeaturesList[key] = false
          }
        })
        if (this.EventMotionSelect != 1) {
          this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
          this.SecondaryHide()
        }
      },
      immediate: true
    }
  },
  created () {
    // 当天零点时间戳
    this.getCurrentZeroTime()
    this.EventMotionSelect = this.EventMotion == 0 || this.EventMotion == 1 ? 1 : this.EventMotion
    // 设置弹出框位置
    this.FrameProperty = JSON.parse(JSON.stringify(this.BoxPosition))
    // 获取时间格式
    this.PickerFormat = Outil.getDateTimePickerFormat()
    // 判断是查看还是编辑
    this.estimateOperate()
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    // 获取source列表
    this.getSourceList()
    // 获取timing列表
    this.getMcpList()
    this.SeetingTimeSignal()
    if (this.picthOnEvent.tpeerid) {
      this.getMediaVideo(this.picthOnEvent.tpeerid, this.picthOnEvent.ttype)
    }
    // 判断编辑还是创建 赋予是否为Hold模式
    if (this.EventMotionSelect == 1) {
      this.IsHoldEvents = this.eventDetail.holdEventRundownTemplate == 1
    } else {
      this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
    }
    this.getExtGfx()
    this.SecondaryHide()
    this.GetConfigParams()
    console.log(this.picthOnEvent)
  },
  mounted () {
    if (this.fixedDevice.version) {
      let { version } = this.fixedDevice
      if (this.fixedDevice.version.length > 3) version = this.fixedDevice.version.substr(0, 3)
      if (version >= '7.6') this.Rversions = true
    }
    this.getCurrentPage()
    commonRequest.getCrawlList().then((res) => {
      this.getCrawlList = res
    })
  },
  methods: {
    // 设置显示参数
    SettingParams (type) {
      this.LiveParams = {
        List: {
          Live: this.AllConfigParams.Live
        },
        search: this.AllConfigParams.search
      }
    },
    getStorage () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/storage'),
        data: {
          programId: ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.enableExternalS3) {
              this.SettingParams('update')
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取多选择组件配置
    GetConfigParams () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.AllConfigParams = SourceConfigParams(programId, this.RegionInfo.bucket)
      this.getStorage()
      this.SettingParams()
    },
    // 子事件文件信息清除
    SubeventClearMessage (item) {
      item.sourceId = ''
      item.fileType = ''
      item.fileName = ''
      item.fileId = ''
      item.sonEventMediaDuration = 0
      // 推送操作
      this.PushUndo()
    },
    // 子事件文件选择
    SubeventFileSelect (pitchOnFile, item, index) {
      let videoTimes = 0
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        if (pitchOnFile.peerId) {
          pitchOnFile.sourceId = pitchOnFile.peerId
        }
        videoTimes = 30 * 60 * 1000
        item.fileId = ''
        item.sonEventMediaDuration = 0
      } else {
        videoTimes = pitchOnFile.videoTimes
        videoTimes = videoTimes * 1000
        this.$set(item, 'fileId', pitchOnFile.id)
        item.sonEventMediaDuration = videoTimes
      }
      if (!item.timingIn) {
        let lastEvent = -1
        if (this.subeventList.length) {
          lastEvent = this.subeventList[index - 1]
        }
        const timingIn = lastEvent != -1 ? lastEvent.timingOut : this.eventDetail.startTime
        item.ShowTimingIn = Outil.changeNewTime(timingIn)
        item.timingIn = timingIn
      }
      item.sourceId = pitchOnFile.sourceId
      item.fileType = pitchOnFile.type
      item.timingOut = item.timingIn + videoTimes
      item.accumulatedProgramTiming = item.timingOut - item.timingIn
      item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
      item.fileName = pitchOnFile.name
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 子事件Live与media选择
    SubeventFileDispose (pitchOnFile, item, index) {
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        this.SubeventFileSelect(pitchOnFile, item, index)
      } else {
        const videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : 0
        pitchOnFile.videoTimes = videoTimes
        // 判断是否是浮点数
        if (parseInt(videoTimes) !== videoTimes) {
          // 判断是否需要取整
          if (this.MediaIsRound) {
            pitchOnFile.videoTimes = Math.floor(videoTimes)
          } else {
            this.MediaTimeFloor.show = true
            this.MediaTimeFloor.file = pitchOnFile
            this.MediaTimeFloor.item = item
            this.MediaTimeFloor.index = index
            this.MediaTimeFloor.type = 'sonEvent'
            return
          }
        }
        this.SubeventFileSelect(pitchOnFile, item, index)
      }
    },
    // duration编辑弹窗
    DurationEditShow (index) {
      this.subeventList.forEach((item, index1) => {
        if (index == index1) {
          item.durationEdit = !item.durationEdit
        } else {
          item.durationEdit = false
        }
      })
    },
    // Secondary类型功能显示隐藏
    SecondaryHide () {
      const List = JSON.parse(JSON.stringify(this.SegmentsType))
      if (this.IsHoldEvents) {
        List[8].isShow = false
      } else {
        List[8].isShow = true
      }
      this.SegmentsType = List
    },
    FlowicsParamSelect (data, item, index) {
      const controls = data.data.controls
      const textArr = Object.values(controls)
      item.iframeInfoParams = {
        id: data.value[2],
        // name: 'Logo',
        state: 'in',
        type: textArr.length == 0 ? 2 : 0,
        title: '',
        value: '',
        sceneId: data.value[0],
        regionId: data.value[1]
      }
      // 先去掉logoText和hashText 再添加
      this.subeventList = this.subeventList.filter(v => {
        return (v.blockId != item.blockId) || (v.iframeInfoParams.type == 0) || (v.iframeInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      let obj
      textArr.forEach((v, i) => {
        obj = {
          segmentId: item.segmentId,
          eventOperationType: item.eventOperationType,
          blockId: item.blockId,
          flowics: 0,
          fileId: '',
          OffsetIn: item.OffsetIn,
          OffsetOut: item.OffsetOut,
          timingIn: item.timingIn,
          timingInTime: '00:00:00',
          timingOut: item.timingOut,
          timingOutTime: '00:00:00',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          black: 0,
          segmentOrder: index + i + 1,
          iframeToken: this.SingularMessage.flowicsToken,
          iframeInfoParams: {
            id: data.value[2],
            // name: 'Logo',
            state: 'in',
            type: 1,
            title: v.id,
            value: v.value,
            sceneId: data.value[0],
            regionId: data.value[1]
          }
        }
        this.subeventList.splice(index + i + 1, 0, obj)
        this.UnderplayClipList[item.blockId] += 1
        // 推送操作
        this.PushUndo()
      })
    },
    // duration修改结束
    DurationEditEnd (DurationObject, subevent, index) {
      subevent.durationEdit = false
      if (DurationObject.type == 'end') {
        subevent.accumulatedProgramTiming = typeof DurationObject.duration == 'number' ? DurationObject.duration : subevent.accumulatedProgramTiming
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
        if (subevent.segmentId == 13) {
          this.countOffset(subevent)
        }
        if (subevent.segmentId == 1) {
          this.countReferenceMedia()
        } else if (subevent.segmentId == 4 || subevent.segmentId == 5 || subevent.segmentId == 10 || ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType != 'Scte only')) {
          this.OtherVideoOvertime(subevent, index)
          // const MediaDuration = subevent.timingOut - subevent.timingIn
          // if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
          //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
          //   this.$message.info(this.$t('lang.mediaTimeOverstep'))
          // }
        }
        this.SegmentTimeFormat()
        // 推送操作
        this.PushUndo()
      }
    },
    // 触发时间选择
    TriggerTimeSelect (type, index) {
      if (type == 'SecondaryOffsetIn') {
        this.$refs.SecondaryOffsetIn[index].focus()
      } else if (type == 'SecondaryOffsetOut') {
        this.$refs.SecondaryOffsetOut[index].focus()
      }
    },
    // 偏移量时间转换
    formatSeconds (time) {
      time = Math.ceil(time / 1000)
      return Outil.formatSecondsChange(time)
    },
    // LogoCraw选择变化
    LogoCrawlChange (pitchOnFile, item) {
      item.fileName = pitchOnFile.name
      this.$set(item, 'fileId', pitchOnFile.fileId)
      // 推送操作
      this.PushUndo()
    },
    singularSelect (item, index) {
      this.subeventList = this.subeventList.filter(v => {
        return (v.blockId != item.blockId) || (v.singularInfoParams.type == 0) || (v.singularInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      const singularItem = this.singularSelectList.filter(v => v.subCompositionName == item.singularInfoParams.subCompositionName)
      const payloadList = Object.keys(singularItem[0].payload)
      const testList = ['title', 'text', 'name', 'string']
      this.numTimes = 0
      if (payloadList.length) {
        payloadList.forEach((v, i) => {
          const IsContain = testList.some(value => v.toLowerCase().includes(value))
          if (IsContain) {
            this.numTimes += 1
            const obj = {
              segmentId: item.segmentId,
              eventOperationType: item.eventOperationType,
              blockId: item.blockId,
              flowics: 0,
              fileId: '',
              OffsetIn: item.OffsetIn,
              OffsetOut: item.OffsetOut,
              timingIn: item.timingIn,
              timingInTime: '00:00:00',
              timingOut: item.timingOut,
              timingOutTime: '00:00:00',
              accumulatedProgramTiming: 0,
              suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
              duration: 0,
              black: 0,
              segmentOrder: index + this.numTimes,
              singularInfoParams: {
                subCompositionName: singularItem[0].subCompositionName,
                state: 'in',
                type: 1,
                payloadKey: v,
                payloadValue: singularItem[0].payload[v]
              }
            }
            this.subeventList.splice(index + this.numTimes, 0, obj)
            this.UnderplayClipList[item.blockId] += 1
          }
        })
        item.singularInfoParams.type = this.numTimes ? 0 : 2
      } else {
        item.singularInfoParams.type = 2
      }
    },
    // 获取singular属性信息
    getSingularInfo () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      if (!this.SingularMessage.token) {
        this.$message.info(this.$t('lang.TokenNotExist'))
        return
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/singular/info', {
        iframeToken: this.SingularMessage.token,
        programId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.singularSelectList = result
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取ExtGfx信息
    getExtGfx () {
      this.axios
        .post(Outil.getUrl('/singular/getSingular'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.SingularMessage = result
            // this.getSingularInfo()
            if (this.SingularMessage.singularStatus == 2 && this.SingularMessage.flowicsToken) {
              if (this.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) return
              this.logoConfig.push({
                value: 'Flowics',
                label: 'Flowics'
              })
            } else {
              if (this.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) {
                this.logoConfig.splice(this.logoConfig.findIndex(item => item.value === 'Flowics'), 1)
              }
            }
            if (!this.SingularMessage.singularStatus) {
              if (this.logoConfig.some(v => {
                return v.value == 'Singular'
              })) return
              this.logoConfig.push({
                value: 'Singular',
                label: 'Singular'
              })
            } else {
              if (this.logoConfig.some(v => {
                return v.value == 'Singular'
              })) {
                this.logoConfig.splice(this.logoConfig.findIndex(item => item.value === 'Singular'), 1)
              }
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch((e) => {
          console.log(e)
        })
    },
    // 切换segmentId==13子事件的类型
    changeSegment (val) {
      if (val.eventOperationType == 'Flowics') {
        val.blockId = Outil.return32Str()
        this.UnderplayClipList[val.blockId] = 1
        val.iframeToken = this.SingularMessage.flowicsToken
      } else if (val.eventOperationType == 'Singular') {
        val.blockId = Outil.return32Str()
        this.UnderplayClipList[val.blockId] = 1
        // this.getSingularInfo()
      }
      // 推送操作
      this.PushUndo(val.eventOperationType)
    },
    getLength (des) {
      return Outil.getByteLength(des)
    },
    // 接收撤回消息
    Undo (data) {
      let item = ''
      Object.keys(data).forEach((key) => {
        if (!this.UndoKey.includes(key)) {
          return
        }
        try {
          item = JSON.parse(data[key])
        } catch (error) {}
        if (typeof item == 'object') {
          this._data[key] = item
        } else {
          this._data[key] = data[key]
        }
      })
    },
    // 发送行为消息
    PushUndo (type) {
      const PreviousAction = {
        ...this.SettingMessage
      }
      const key = (type == 'input' || type == 'inputEnd' || type == 'lastStep') ? type : ''
      PreviousAction.CompileType = this.CompileType
      PreviousAction.IsCopyEvent = this.IsCopyEvent
      PreviousAction.EventMotionSelect = this.EventMotionSelect
      PreviousAction.eventDetail = JSON.stringify(this.eventDetail)
      PreviousAction.subeventList = JSON.stringify(this.subeventList)
      PreviousAction.UnderplayClipList = JSON.stringify(this.UnderplayClipList)
      if (type == 'clearUndo') {
        this.UndoActionPro.clearUndo(PreviousAction)
      } else {
        this.UndoActionPro.pushUndo(PreviousAction, key)
      }
    },
    // 切换tab
    CutTab (key) {
      if (this.CompileType != key) {
        this.CompileType = key
        this.PushUndo()
      }
    },
    // 设置TimeSignal选项的
    SeetingTimeSignal () {
      const ProgramRMessage = Outil.getProgramReceiver()
      const List = JSON.parse(JSON.stringify(this.SegmentsType))
      if (ProgramRMessage.scteType) {
        List[2].isShow = false
      } else {
        List[3].isShow = false
      }
      this.SegmentsType = List
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/scte'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            Object.keys(result.timeSignalScte).forEach(key => {
              this.SubeventTypeSelete.TimeSignalList.push({
                value: key,
                label: key,
                key: result.timeSignalScte[key]
              })
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 当天开始时间时间戳
    getCurrentZeroTime () {
      const today = new Date()
      const y = today.getFullYear()
      let TimeQuantum = Outil.getProgramReceiver('broadcastDay')
      if (this.picthOnEvent.absoluteTime != null && this.picthOnEvent.absoluteTime != undefined) {
        TimeQuantum = this.picthOnEvent.absoluteTime
      }
      const CurrentZero = `1/1/${y}`
      this.timeDifference = new Date(CurrentZero).getTime()
      if (TimeQuantum) {
        this.timeDifference = this.timeDifference + TimeQuantum * 60 * 60 * 1000
      }
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 获取media的信息
    getMediaVideo (sourceId, type) {
      if (['video', 'file', 'json'].includes(type)) {
        this.axios.post(Outil.getUrl(`/fileInfoNew/getFileInfoBySourceId?sourceId=${sourceId}`))
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.videoTimes = res.data.result.videoTimes ? res.data.result.videoTimes : 0
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      } else {
        this.videoTimes = 30 * 60
      }
    },
    // 获取scte时间间隔
    getScteDuration () {
      if (!this.picthOnEvent.templateId) {
        this.ScteDuration = 90
        return
      }
      this.axios.post(Outil.getUrl('/eventTemplate/getById'), {
        id: this.picthOnEvent.templateId
      })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.ScteDuration = res.data.result.scteSpliceDurationDefault
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    },
    // 处理子事件没有name问题
    SetSubeventName (item) {
      let Name = item.eventOperationType
      if (!Name) {
        const SegmentsItem = this.SegmentsType.filter(
          (m) => m.value == item.segmentId
        )
        Name = SegmentsItem[0].label
      }
      return Name
    },
    // 更改创建开始时间
    changeStartTime (val) {
      const ShowDate = Outil.changeNewDate(val, 1)
      if (ShowDate != this.eventDetail.newdate) {
        const ShowTime = Outil.changeNewTime(val)
        this.eventDetail.startTime = new Date(`${this.eventDetail.newdate} ${ShowTime}`).getTime()
      }
      //   编辑的时候
      if (this.EventMotionSelect == 1 || (this.EventMotionSelect == 2 && this.IsCopyEvent)) {
        const durTime = this.AllEventTime.EventTime
        this.eventDetail.endTime = this.eventDetail.startTime + durTime
      }

      if (this.eventDetail.endTime && this.eventDetail.endTime - this.eventDetail.startTime < 0) {
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
      this.setSubeventDateLimit()
      this.UpdateSourceTime()
      // 推送操作
      this.PushUndo()
    },
    // 更改创建结束时间
    changeEndTime (val) {
      // 创建或者复制的时候
      const ShowDate = Outil.changeNewDate(val, 1)
      if (this.eventDetail.endTime - this.eventDetail.startTime < 0 && ShowDate != this.eventDetail.newdate) {
        const ShowTime = Outil.changeNewTime(val)
        this.eventDetail.endTime = new Date(`${this.eventDetail.newdate} ${ShowTime}`).getTime()
      }
      if (
        this.eventDetail.endTime &&
        this.eventDetail.endTime - this.eventDetail.startTime < 0
      ) {
        this.eventDetail.endTime = null
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
      if (!this.IsHoldEvents) {
        this.UpdateSourceTime()
      }
      // 推送操作
      this.PushUndo()
    },
    // 修改主事件时间时更新子事件时间
    UpdateSourceTime () {
      // sourceType 1:source 0:media
      if (this.eventDetail.sourceType && this.subeventList.length > 0) {
        let count = 0
        const RefenrenceIndex = []
        this.subeventList.forEach((item, index) => {
          if (item.segmentId == 1) {
            count++
            RefenrenceIndex.push(index)
          }
        })
        const LastEventIndex = this.subeventList.length - 1
        const timeRemaining = this.eventDetail.endTime - this.subeventList[LastEventIndex].timingOut
        let LastMedia = {}
        if (count > 0) {
          LastMedia = this.subeventList[RefenrenceIndex[count - 1]]
        } else if (timeRemaining > 0) {
          if (this.subeventList[LastEventIndex].segmentId == 7) {
            const timingIn = LastEventIndex - 1 >= 0 ? this.subeventList[LastEventIndex - 1].timingOut : this.eventDetail.startTime
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.splice(LastEventIndex, 0, {
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn,
              accumulatedProgramTiming: 0
            })
            LastMedia = this.subeventList[LastEventIndex]
          } else {
            const timingIn = this.subeventList[LastEventIndex].timingOut
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.push({
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn
            })
            LastMedia = this.subeventList[LastEventIndex + 1]
          }
        } else {
          return
        }
        LastMedia.timingOut = LastMedia.timingOut + timeRemaining
        LastMedia.accumulatedProgramTiming = LastMedia.timingOut - LastMedia.timingIn
        if (LastMedia.accumulatedProgramTiming < 0) {
          LastMedia.timingOut = LastMedia.timingIn
        }
        LastMedia.ShowTimingOut = Outil.changeNewTime(LastMedia.timingOut)
        this.SegmentTimeFormat()
      }
    },
    // 文件选择变化
    fileSeleteChange (pitchOnFile, item, index) {
      // 主文件选择
      if (item === 1) {
        this.eventDetail.tname = pitchOnFile.name
        this.eventDetail.tpeerid = pitchOnFile.sourceId
        this.eventDetail.ttype = pitchOnFile.type
        this.eventDetail.fileId = pitchOnFile.id
        let videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : pitchOnFile.videoTimes
        this.videoTimes = videoTimes
        videoTimes = videoTimes * 1000
        this.FillingTime(videoTimes, 1)
        // this.$set(this.eventDetail, 'tpeerid', pitchOnFile.sourceId);
      } else {
        let videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : pitchOnFile.videoTimes
        videoTimes = videoTimes * 1000
        if (!item.timingIn) {
          let lastEvent = -1
          if (this.subeventList.length) {
            lastEvent = this.subeventList[index - 1]
          }
          const timingIn = lastEvent != -1 ? lastEvent.timingOut : this.eventDetail.startTime
          item.ShowTimingIn = Outil.changeNewTime(timingIn)
          item.timingIn = timingIn
        }
        item.sourceId = pitchOnFile.sourceId
        item.fileType = pitchOnFile.type
        item.timingOut = item.timingIn + videoTimes
        item.accumulatedProgramTiming = item.timingOut - item.timingIn
        item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
        item.fileName = pitchOnFile.name
        this.$set(item, 'fileId', pitchOnFile.id)
        this.SegmentTimeFormat()
      }
      // 推送操作
      this.PushUndo()
    },
    // 修改文件时填充时间更改
    FillingTime (videoTimes, type) {
      if (this.IsHoldEvents) {
        if (this.subeventList.length == 0) {
          this.subeventList.push({
            segmentId: 1,
            segmentOrder: 0,
            SerialNumber: 1,
            ShowTimingIn: '',
            timingIn: 0,
            ShowTimingOut: '',
            timingOut: 0,
            accumulatedProgramTiming: 0
          })
          this.SegmentTimeFormat()
        }
        return
      }
      // if (this.eventDetail.startTime && videoTimes) {
      //   this.eventDetail.endTime = videoTimes + this.eventDetail.startTime
      // }
      let totalTime = 0
      let LastIndex = 0
      let count = 0
      // 有子事件的处理
      // if (this.subeventList.length > 0) {
      this.subeventList.forEach((item, index) => {
        if (item.segmentId == 1) {
          totalTime += item.accumulatedProgramTiming
          LastIndex = index
          count++
        }
      })
      const LastEventIndex = this.subeventList.length - 1
      const timeRemaining = videoTimes - totalTime
      let LastMedia = {}
      // 判断reference是source类型
      if (this.eventDetail.sourceType == 1 || type == 2) {
        if (count == 0) {
          if (LastEventIndex != -1 && this.subeventList[LastEventIndex].segmentId == 7) {
            const timingIn = LastEventIndex - 1 >= 0 ? this.subeventList[LastEventIndex - 1].timingOut : this.eventDetail.startTime
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.splice(LastEventIndex, 0, {
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn,
              accumulatedProgramTiming: 0
            })
            LastMedia = this.subeventList[LastEventIndex]
          } else {
            const timingIn = LastEventIndex == -1 ? this.eventDetail.startTime : this.subeventList[LastEventIndex].timingOut
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.push({
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn,
              accumulatedProgramTiming: 0
            })
            LastMedia = this.subeventList[LastEventIndex + 1]
          }
          LastMedia.timingOut = LastMedia.timingOut + timeRemaining
          LastMedia.accumulatedProgramTiming = LastMedia.timingOut - LastMedia.timingOut
          LastMedia.ShowTimingOut = Outil.changeNewTime(LastMedia.timingOut)
        }
        this.SegmentTimeFormat()
        return
      }
      // 判断reference是media类型
      if (type == 1) {
        if (count > 0) {
          LastMedia = this.subeventList[LastIndex]
        } else if (timeRemaining > 0) {
          if (LastEventIndex != -1 && this.subeventList[LastEventIndex].segmentId == 7) {
            const timingIn = LastEventIndex - 1 >= 0 ? this.subeventList[LastEventIndex - 1].timingOut : this.eventDetail.startTime
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.splice(LastEventIndex, 0, {
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn,
              accumulatedProgramTiming: 0
            })
            LastMedia = this.subeventList[LastEventIndex]
          } else {
            const timingIn = LastEventIndex != -1 ? this.subeventList[LastEventIndex].timingOut : this.eventDetail.startTime
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.push({
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn
            })
            LastMedia = this.subeventList[LastEventIndex + 1]
          }
        } else {
          return
        }
        LastMedia.timingOut = LastMedia.timingOut + timeRemaining
        LastMedia.accumulatedProgramTiming = LastMedia.timingOut - LastMedia.timingIn
        LastMedia.ShowTimingOut = Outil.changeNewTime(LastMedia.timingOut)
        this.SegmentTimeFormat()
        return
      }

      // 判断视频超过timing
      if (timeRemaining > 0) {
        // 判断最后是否是结束
        if (LastEventIndex != -1 && this.subeventList[LastEventIndex].segmentId == 7) {
          // 判断倒数第二个是不是主视频
          if (LastEventIndex - 1 >= 0 && this.subeventList[LastEventIndex - 1].segmentId == 1) {
            LastMedia = this.subeventList[LastEventIndex - 1]
          } else {
            const timingIn = LastEventIndex - 1 >= 0 ? this.subeventList[LastEventIndex - 1].timingOut : this.eventDetail.startTime
            const ShowTimingIn = Outil.changeNewTime(timingIn)
            this.subeventList.splice(LastEventIndex, 0, {
              segmentId: 1,
              SerialNumber: count + 1,
              ShowTimingIn,
              timingIn,
              ShowTimingOut: ShowTimingIn,
              timingOut: timingIn,
              accumulatedProgramTiming: 0
            })
            LastMedia = this.subeventList[LastEventIndex]
          }
          // 判断最后一个是不是主视频
        } else if (LastEventIndex != -1 && this.subeventList[LastEventIndex].segmentId == 1) {
          LastMedia = this.subeventList[LastEventIndex]
        } else {
          const timingIn = LastEventIndex == -1 ? this.eventDetail.startTime : this.subeventList[LastEventIndex].timingOut
          const ShowTimingIn = Outil.changeNewTime(timingIn)
          this.subeventList.push({
            segmentId: 1,
            SerialNumber: count + 1,
            ShowTimingIn,
            timingIn,
            ShowTimingOut: ShowTimingIn,
            timingOut: timingIn,
            accumulatedProgramTiming: 0
          })
          LastMedia = this.subeventList[LastEventIndex + 1]
        }
        LastMedia.timingOut = LastMedia.timingOut + timeRemaining
        LastMedia.accumulatedProgramTiming = LastMedia.timingOut - LastMedia.timingIn
        LastMedia.ShowTimingOut = Outil.changeNewTime(LastMedia.timingOut)
      } else {
        // 判断视频时间长度不够
        const LastDuration = this.subeventList[LastIndex].accumulatedProgramTiming
        if (videoTimes - totalTime + LastDuration > 0) {
          this.subeventList[LastIndex].timingOut = this.subeventList[LastIndex].timingOut + timeRemaining
          this.subeventList[LastIndex].accumulatedProgramTiming = this.subeventList[LastIndex].timingOut - this.subeventList[LastIndex].timingIn
          this.subeventList[LastIndex].ShowTimingOut = Outil.changeNewTime(this.subeventList[LastIndex].timingOut)
        }
      }
      this.SegmentTimeFormat()
    },
    // 子事件时间格式化
    SegmentTimeFormat (timeLock) {
      if (this.subeventList.length <= 0) {
        this.PGMScteMessage.PGMTotalTime = ''
        return
      }
      let parent = {}
      let lastEvent = {}
      let maxTime = 0
      // PGMSCTE的信息展示
      const ScteMessage = {
        maxTime: 0,
        TotalTime: 0,
        ScteNumber: 0
      }
      this.subeventList.forEach((item, index) => {
        if (item.timingIn != undefined && item.timingOut != undefined) {
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
        }
        if (item.accumulatedProgramTiming < 0) {
          item.accumulatedProgramTiming = 0
        }
        ScteMessage.maxTime += item.accumulatedProgramTiming
        if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
          ScteMessage.TotalTime += item.accumulatedProgramTiming
          ScteMessage.ScteNumber++
        }
        if (item.segmentId != 13) {
          if (index == 0) {
            item.timingIn = this.eventDetail.startTime
            item.timingOut = item.timingIn + item.accumulatedProgramTiming
          } else {
            item.timingIn = lastEvent.timingOut
            item.timingOut = item.timingIn + item.accumulatedProgramTiming
          }
          item.segmentOrder = index
          item.ShowTimingIn = Outil.changeNewTime(item.timingIn)
          item.ShowTimingOut = Outil.changeNewTime(item.timingOut)
          maxTime = item.timingOut
          // Underplay Block时间为一组时间
          if (item.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && item.blockId == parent.blockId) {
            parent.timingOut = item.timingOut
          } else {
            // 避免使用JSON 这种方式更高效
            parent = Object.assign({}, item)
          }
          lastEvent = item
        } else {
          item.segmentOrder = index
          item.timingIn = item.OffsetIn + parent.timingIn
          item.timingOut = item.OffsetOut + parent.timingOut
          item.ShowTimingIn = Outil.changeNewTime(item.timingIn)
          item.ShowTimingOut = Outil.changeNewTime(item.timingOut)
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
        }
      })
      this.PGMScteMessage.PGMTotalTime = ScteMessage.maxTime > 0 ? Outil.getDuration(ScteMessage.maxTime) : ''
      this.PGMScteMessage.ScteTotalTime = Outil.getDuration(ScteMessage.TotalTime)
      this.PGMScteMessage.ScteNumber = ScteMessage.ScteNumber
      if (maxTime > 0 && (!this.IsHoldEvents || maxTime > this.eventDetail.endTime) && (!timeLock || this.eventDetail.timeLock != 1 || maxTime > this.eventDetail.endTime)) {
        this.eventDetail.endTime = maxTime
      }
    },
    // 子事件Segments变化
    SegmentsChang (item) {
      item.sourceId = ''
      item.fileName = ''
      item.blockId = ''
      item.UnderplayClip = ''
      item.timingOut = item.timingIn
      item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
      item.accumulatedProgramTiming = 0
      // 清空事件选择以及文件选择
      this.$set(item, 'eventOperationType', null)
      this.$set(item, 'fileId', null)
      item.sonEventMediaDuration = 0
      if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
        item.timingOut = item.timingIn + this.ScteDuration * 1000
        item.accumulatedProgramTiming = item.timingOut - item.timingIn
        item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
        this.getTemplate(item, 0)
        this.$set(item, 'eventOperationType', 'Scte only')
      } else if (item.segmentId == 13) {
        this.$set(item, 'eventOperationType', 'Logo')
        item.iframeInfoParams = {
          id: '',
          // name: 'Logo',
          state: 'in',
          type: '',
          title: '',
          value: '',
          sceneId: '',
          regionId: ''
        }
        item.singularInfoParams = {
          subCompositionName: '',
          state: 'in',
          type: 0,
          payloadKey: '',
          payloadValue: ''
        }
        item.OffsetIn = 0
        item.OffsetOut = 0
        // 添加logo，crawl校验
        // this.TypeChecking(item, index)
      }
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 删除子事件
    deleteSubevent (subevent, index) {
      // 编辑时删除的已经存在的子事件
      let DeleteSubeventList = []
      if ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType == 'Underplay Block') {
        if (subevent.UnderplayClip) {
          DeleteSubeventList = this.subeventList.splice(index, this.UnderplayClipList[subevent.blockId])
        } else {
          DeleteSubeventList = this.subeventList.splice(index, 1)
          this.UnderplayClipList[subevent.blockId] -= 1
        }
      } else if (subevent.segmentId == 13 && (subevent.eventOperationType == 'Flowics' || subevent.eventOperationType == 'Singular')) {
        DeleteSubeventList = this.subeventList.splice(index, this.UnderplayClipList[subevent.blockId])
      } else {
        DeleteSubeventList = this.subeventList.splice(index, 1)
      }
      // 编辑时删除的已经存在的子事件
      DeleteSubeventList.forEach(item => {
        if (item.id) {
          this.DeleteSubeventList.push(item)
        }
      })

      // 子事件时间格式化
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 添加子事件
    addSubevent (type, index, item) {
      // let lastEvent = -1
      // let segmentOrder = 0
      // if (this.subeventList.length) {
      //   lastEvent = this.subeventList[this.subeventList.length - 1]
      //   segmentOrder = this.subeventList.length
      // }
      // const timingIn = lastEvent != -1 ? lastEvent.timingOut : this.eventDetail.startTime
      // const ShowTimingIn = Outil.changeNewTime(timingIn)
      // this.subeventList.push({
      //   ShowTimingIn,
      //   timingIn,
      //   ShowTimingOut: ShowTimingIn,
      //   timingOut: timingIn,
      //   segmentOrder,
      //   accumulatedProgramTiming: 0
      // })
      // // 推送操作
      // this.PushUndo()
      let segmentOrder = 0
      if (type == 'end') {
        segmentOrder = this.subeventList.length
      } else {
        segmentOrder = index + 1
        if (((item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) && item.eventOperationType == 'Underplay Block') || (item.segmentId == 13 && (item.eventOperationType == 'Flowics' || item.eventOperationType == 'Singular'))) {
          segmentOrder = index + this.UnderplayClipList[item.blockId]
        }
      }
      const subevent = {
        ShowTimingIn: '',
        timingIn: 0,
        ShowTimingOut: '',
        timingOut: 0,
        segmentOrder,
        accumulatedProgramTiming: 0,
        durationEdit: false
      }
      if (type == 'end') {
        this.subeventList.push(subevent)
      } else {
        this.subeventList.splice(segmentOrder, 0, subevent)
      }
      this.SegmentTimeFormat()
      // 推送操作
      this.PushUndo()
    },
    // 计算偏移量
    countOffset (subevent) {
      let parent = {}
      let IsHint = false
      this.subeventList.forEach((item, index) => {
        if (item.segmentId != 13) {
          // Underplay Block时间为一组时间
          if (item.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && item.blockId == parent.blockId) {
            parent.timingOut = item.timingOut
          } else {
            parent = JSON.parse(JSON.stringify(item))
          }
        } else {
          if (!(parent.timingIn <= item.timingIn && item.timingIn <= parent.timingOut)) {
            item.timingIn = parent.timingIn
            if (!IsHint && parent.timingOut) {
              IsHint = true
              if (item.iframeInfoParams && item.iframeInfoParams.type != 1) {
                this.$message.info(this.$t('lang.SecondaryStartTime'))
              }
            }
          }
          if (!(parent.timingIn <= item.timingOut && item.timingOut <= parent.timingOut)) {
            item.timingOut = parent.timingOut
          }
          item.OffsetIn = item.timingIn - parent.timingIn
          item.OffsetOut = item.timingOut - parent.timingOut
        }
      })
      if (subevent && subevent.segmentId == 13 && subevent.eventOperationType == 'Flowics') {
        this.subeventList = this.subeventList.map((item, index) => {
          if (item.blockId == subevent.blockId && item.iframeInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == subevent.blockId && item.iframeInfoParams.type == 1) {
            return {
              ...item,
              OffsetIn: this.mainFlowicsParams.OffsetIn,
              OffsetOut: this.mainFlowicsParams.OffsetOut,
              ShowTimingIn: this.mainFlowicsParams.ShowTimingIn,
              ShowTimingOut: this.mainFlowicsParams.ShowTimingOut,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      } else if (subevent && subevent.segmentId == 13 && subevent.eventOperationType == 'Singular') {
        this.subeventList = this.subeventList.map((item, index) => {
          if (item.blockId == subevent.blockId && item.singularInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == subevent.blockId && item.singularInfoParams.type == 1) {
            return {
              ...item,
              OffsetIn: this.mainFlowicsParams.OffsetIn,
              OffsetOut: this.mainFlowicsParams.OffsetOut,
              ShowTimingIn: this.mainFlowicsParams.ShowTimingIn,
              ShowTimingOut: this.mainFlowicsParams.ShowTimingOut,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      }
    },
    // 子事件的时间校验以及计算时间间隔
    DateChange (subevent, type, index) {
      // 赋予时间
      if (subevent.ShowTimingIn) {
        subevent.timingIn = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingIn}`
        ).getTime()
      }
      if (subevent.ShowTimingOut) {
        subevent.timingOut = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingOut}`
        ).getTime()
      }
      if (type == 'In') {
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
        subevent.ShowTimingOut = Outil.changeNewTime(subevent.timingOut)
        // 修改第一个事件的开始时间做同步主事件时间
        if (index == 0 && subevent.timingIn) {
          this.eventDetail.startTime = subevent.timingIn
          this.AllEventTime.EventStarttime = this.eventDetail.startTime
        }
      }
      // 结束时间应大于开始时间
      if (subevent.timingIn && subevent.timingOut && subevent.timingOut - subevent.timingIn < 0) {
        const newdate = Outil.changeNewDate(subevent.timingOut + 24 * 60 * 60 * 1000, 1)
        subevent.timingOut = new Date(`${newdate} ${subevent.ShowTimingOut}`).getTime()
        subevent.ShowTimingOut = Outil.changeNewTime(subevent.timingOut)
      }
      // 计算时间间隔
      if (subevent.timingIn && subevent.timingOut) {
        this.$set(
          subevent,
          'accumulatedProgramTiming',
          subevent.timingOut - subevent.timingIn
        )
      }

      if (subevent.timingIn < this.eventDetail.startTime) {
        const newdate = Outil.changeNewDate(subevent.timingIn + 24 * 60 * 60 * 1000, 1)
        subevent.timingIn = new Date(`${newdate} ${subevent.ShowTimingIn}`).getTime()
        subevent.timingOut = subevent.timingIn + subevent.accumulatedProgramTiming
      }

      if (subevent.segmentId == 13) {
        this.countOffset(subevent)
      }
      if (subevent.segmentId == 1) {
        this.countReferenceMedia()
      } else if (subevent.segmentId == 4 || subevent.segmentId == 5 || subevent.segmentId == 10 || ((subevent.segmentId == 2 || subevent.segmentId == 11 || subevent.segmentId == 14) && subevent.eventOperationType != 'Scte only')) {
        this.OtherVideoOvertime(subevent, index)
        // const MediaDuration = subevent.timingOut - subevent.timingIn
        // if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
        //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
        //   this.$message.info(this.$t('lang.mediaTimeOverstep'))
        // }
      }
      // 子事件时间格式化
      this.SegmentTimeFormat()
    },
    // 计算子事件Reference Media时间
    countReferenceMedia (sourceDuration, type) {
      // media总时长
      let MediaTotalDuration = 0
      this.subeventList.forEach((item) => {
        if (item.segmentId === 1) {
          const eventDuration = item.timingOut - item.timingIn
          MediaTotalDuration += eventDuration
        }
      })
      // 主时间变化时
      if (type === 'main') {
        const length = this.subeventList.length
        if (length === 0) return
        const timeRemaining = this.eventDetail.endTime - this.subeventList[length - 1].timingOut
        let addMediatotal = MediaTotalDuration + timeRemaining
        addMediatotal = addMediatotal <= 0 ? 0 : addMediatotal
        if (!this.eventDetail.sourceType && this.eventDetail.eventMediaDuration && addMediatotal > this.eventDetail.eventMediaDuration) {
          // this.TimeReferenceMedia(this.eventDetail.eventMediaDuration)
          // this.$message.info(this.$t('lang.mediaTimeOverstep'))
          // console.log('111111111')
          this.MainVideoOvertime(this.eventDetail.eventMediaDuration, addMediatotal)
          return
        }
        this.TimeReferenceMedia(addMediatotal)
        return
      }
      // 类型为Media时，时间变化
      if (!this.eventDetail.sourceType && this.eventDetail.eventMediaDuration && MediaTotalDuration > this.eventDetail.eventMediaDuration) {
        // this.TimeReferenceMedia(this.eventDetail.eventMediaDuration)
        // this.$message.info(this.$t('lang.mediaTimeOverstep'))
        this.MainVideoOvertime(this.eventDetail.eventMediaDuration)
      } else if (this.eventDetail.sourceType && MediaTotalDuration == 0 && sourceDuration) {
        // 类型为Live并且Reference Media为0时，更新
        this.TimeReferenceMedia(sourceDuration)
      }
    },
    // 主视频选择时间超出视频时间
    MainVideoOvertime (actualTime, setTime) {
      if (this.EventOverLoop === 1) {
        if (setTime) this.TimeReferenceMedia(setTime)
      } else if (this.EventOverLoop === 2) {
        if (actualTime) this.TimeReferenceMedia(actualTime)
      } else {
        this.OverVideoTime = {
          show: true,
          type: 'main',
          actualTime,
          setTime
        }
      }
      // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
      //   confirmButtonText: this.$t('lang.Confirm'),
      //   cancelButtonText: this.$t('lang.cancel'),
      //   dangerouslyUseHTMLString: true
      // }).then(() => {
      //   if (setTime) this.TimeReferenceMedia(setTime)
      // }).catch(() => {
      //   if (actualTime) this.TimeReferenceMedia(actualTime)
      // })
    },
    // 根据时间增加删除Reference Media
    TimeReferenceMedia (videoTime) {
      const obj = {
        segmentId: 1,
        segmentOrder: 0,
        SerialNumber: 1,
        ShowTimingIn: '',
        timingIn: 0,
        ShowTimingOut: '',
        timingOut: 0,
        accumulatedProgramTiming: 0,
        durationEdit: false
      }
      const EventLength = this.subeventList.length
      if (this.IsHoldEvents) {
        if (EventLength == 0) {
          this.subeventList.push(obj)
          this.SegmentTimeFormat()
        }
        return
      }
      if (EventLength > 0) {
        let timeLeft = videoTime
        let LastMedia = null
        for (let i = 0; i < EventLength; i++) {
          const item = this.subeventList[i]
          if (!item || item.segmentId !== 1) {
            continue
          }
          const eventDuration = item.timingOut - item.timingIn
          if (timeLeft == 0) {
            this.subeventList.splice(i, 1)
            i--
          } else if (eventDuration >= timeLeft) {
            item.timingOut = item.timingIn + timeLeft
            timeLeft = 0
          } else if (eventDuration < timeLeft) {
            timeLeft -= eventDuration
          }
          LastMedia = item
        }
        if (timeLeft > 0) {
          if (LastMedia) {
            LastMedia.timingOut = LastMedia.timingOut + timeLeft
          } else if (this.subeventList[EventLength - 1].segmentId == 7) {
            obj.segmentOrder = EventLength - 1
            obj.timingOut = obj.timingIn + timeLeft
            this.subeventList.splice(EventLength - 1, 0, obj)
          } else {
            obj.segmentOrder = EventLength
            obj.timingOut = obj.timingIn + timeLeft
            this.subeventList.push(obj)
          }
        }
      } else {
        obj.timingOut = obj.timingIn + videoTime
        this.subeventList.push(obj)
      }
      this.SegmentTimeFormat()
    },
    // 其他视频选择时间超出视频时间
    OtherVideoOvertime (subevent, index) {
      const MediaDuration = subevent.timingOut - subevent.timingIn
      if (subevent.sonEventMediaDuration && MediaDuration > subevent.sonEventMediaDuration) {
        if (this.EventOverLoop === 2) {
          subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
          // 子事件时间格式化
          this.SegmentTimeFormat()
        } else if (this.EventOverLoop != 1) {
          this.OverVideoTime = {
            show: true,
            type: 'sub',
            index
          }
        }
        // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
        //   confirmButtonText: this.$t('lang.Confirm'),
        //   cancelButtonText: this.$t('lang.cancel'),
        //   dangerouslyUseHTMLString: true
        // }).then(() => {}).catch(() => {
        //   subevent.timingOut = subevent.sonEventMediaDuration + subevent.timingIn
        //   // 子事件时间格式化
        //   this.SegmentTimeFormat()
        // })
      }
    },
    // 搜索source
    SearchSource (value) {
      this.SourcePaging.pageNum = 0
      this.SourcePaging.condition = value
      this.SourcePaging.loadEnd = false
      this.getSourceList()
    },
    // 获取source列表
    getSourceList () {
      this.SourcePaging.pageNum++
      this.SourcePaging.programId = this.$BehaviorSyns.getProgramId()
      if (!this.SourcePaging.loadEnd) {
        this.axios.post(Outil.getUrl('/device/pageSourceDevice'), this.SourcePaging)
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              const { result } = res.data
              if (result.list) {
                if (this.SourcePaging.pageNum == 1) {
                  this.SourceList = result.list
                } else {
                  this.SourceList.push(...result.list)
                }
              }
              if (result.list.length < 35) {
                this.SourcePaging.loadEnd = true
              }
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      }
    },
    // 选择source
    SelectSource (peerId) {
      const FileMessage = this.SourceList.filter((item) => item.peerId === peerId)
      this.eventDetail.tname = FileMessage[0].name
      // this.eventDetail.tpeerid = FileMessage[0].peerId;
      this.$set(this.eventDetail, 'tpeerid', FileMessage[0].peerId)
      this.eventDetail.ttype = FileMessage[0].type
      const videoTimes = 30 * 60 * 1000
      this.videoTimes = 30 * 60
      this.FillingTime(videoTimes, 2)
      // 推送操作
      this.PushUndo()
    },
    // 空白占位符选择文件后编辑颜色
    BlankEditColor () {
      if (this.eventDetail.color == 'rgb(255, 255, 255)' && this.eventDetail.tpeerid) {
        this.eventDetail.color = 'rgb(255, 192, 0)'
      }
    },
    // 选择颜色
    chooseColor (item) {
      this.eventDetail.color = item.value
      this.mostSwitch.ColorShow = false
      this.PushUndo()
    },
    // 复制事件
    copyEvent () {
      this.EventMotionSelect = 2
      this.eventDetail.liveStatus = 0
      this.IsCopyEvent = true
      this.subeventList.forEach((item) => {
        delete item.id
      })
      this.PushUndo()
    },
    // 请求前参数处理
    RequestBeforeData (type) {
      // this.eventDetail.eventSegments = []
      // this.eventDetail.addEventSegments = []
      // this.eventDetail.deleteEventSegments = []
      const EventMessage = JSON.parse(JSON.stringify(this.eventDetail))
      EventMessage.startTime = EventMessage.startTime - this.timeDifference
      EventMessage.endTime = EventMessage.endTime - this.timeDifference
      if (!EventMessage.tpeerid) {
        EventMessage.color = 'rgb(255, 255, 255)'
      }
      const subeventList = JSON.parse(JSON.stringify(this.subeventList))
      // type 1 编辑 0创建
      subeventList.forEach((item) => {
        item.timingIn = item.timingIn - this.timeDifference
        item.timingOut = item.timingOut - this.timeDifference
      })
      EventMessage.segmentVos = subeventList
      const param = EventMessage
      param.record = param.record ? 1 : 0
      const index = subeventList.length > 0 ? subeventList.length - 1 : -1
      if ((index != -1 && subeventList[index].timingOut > param.endTime) && EventMessage.tpeerid) {
        param.endTime = subeventList[index].timingOut
      }
      return param
    },
    // 保存事件 type 1编辑 0创建
    SaveEvent (type) {
      this.BlankEditColor()
      const param = this.RequestBeforeData(type)
      param.holdEventRundownTemplate = this.IsHoldEvents ? 1 : 0

      if (!param.title && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (param.title.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedName')}`)
        return
      }
      if (type) {
        this.$emit('saveBooking', param)
      } else {
        this.$emit('createBooking', param)
      }
    },
    // 删除事件
    DeleteEvent () {
      this.$emit('deleteBooking')
    },
    // 保存 删除 创建 操作成功
    OperationSuccess () {
      this.$emit('OperationSuccess')
    },
    // 关闭弹出框
    closeCreateBox () {
      this.$emit('closeBooking')
    },
    // DelayBit变化
    DelayBitChange (key) {
      this.mostSwitch[key] = false
      if (key == 'editDelay') {
        let delay
        if (this.eventDetail.delay) {
          delay = Number(this.eventDetail.delay.replace(/[^\d.]/g, ''))
        }
        if (this.Rversions) {
          this.eventDetail.delay = delay < 0.3 ? '0.3' : this.eventDetail.delay
        } else {
          this.eventDetail.delay = delay < 0.5 ? '0.5' : this.eventDetail.delay
        }
        this.eventDetail.delay = delay > 50 ? '50' : this.eventDetail.delay
      } else if (key == 'editBit') {
        let bitrate
        if (this.eventDetail.bitrate) {
          bitrate = Number(this.eventDetail.bitrate.replace(/[^\d.]/g, ''))
        }
        this.eventDetail.bitrate =
          bitrate < 100 ? '100' : this.eventDetail.bitrate
        this.eventDetail.bitrate =
          bitrate > 10240 ? '10240' : this.eventDetail.bitrate
      }
      // 推送操作
      this.PushUndo()
    },
    // 转换颜色
    ColorTransition (color) {
      const colorName = this.colorArr.filter((item) => item.value == color)
      return colorName[0] ? colorName[0].name : 'purple'
    },
    // 判断是查看还是创建，赋予数据
    estimateOperate () {
      this.picthOnEvent.sourceType = 0
      this.eventDetail = JSON.parse(JSON.stringify(this.picthOnEvent))
      this.eventDetail.startTime = this.eventDetail.startTime + this.timeDifference
      this.eventDetail.endTime = this.eventDetail.endTime + this.timeDifference
      this.eventDetail.record = !!this.eventDetail.record
      this.eventDetail.color = this.eventDetail.color
        ? this.eventDetail.color
        : 'rgb(255, 192, 0)'
      //   计算事件的时长，时间间隔
      this.eventDetail.duration = this.eventDetail.duration
        ? this.eventDetail.duration
        : this.eventDetail.endTime - this.eventDetail.startTime
      //   查看和编辑
      if (this.EventMotionSelect == 0 || this.EventMotionSelect == 1) {
        // 判断源是视频还是t
        if (this.eventDetail.ttype) {
          if (
            ['video', 'file'].includes(
              this.eventDetail.ttype && this.eventDetail.ttype.toLowerCase()
            )
          ) {
            this.eventDetail.sourceType = 0
          } else {
            this.eventDetail.sourceType = 1
          }
        }
        // 取delay,bitrate
        if (this.eventDetail.parameters) {
          const parameters =
            typeof this.eventDetail.parameters == 'object'
              ? this.eventDetail.parameters
              : JSON.parse(this.eventDetail.parameters)
          this.eventDetail.reporter = parameters.reporter
          this.eventDetail.delay = parameters.delay
          this.eventDetail.bitrate = parameters.bitrate
        }
      }
      //   子事件
      if (this.eventDetail.segmentVos) {
        this.subeventSwitch = this.eventDetail.segmentVos.length > 0 ? 1 : 0
        const subeventList = JSON.parse(
          JSON.stringify(this.eventDetail.segmentVos)
        )
        subeventList.forEach((item) => {
          item.timingIn = item.timingIn + this.timeDifference
          item.timingOut = item.timingOut + this.timeDifference
          if (item.segmentId == 13 && item.fileId && item.fileId.startsWith('0x_')) {
            item.fileIdd = item.fileId.slice(3, item.fileId.length)
            item.showColor = true
          } else {
            item.fileIdd = item.fileId
            item.showColor = false
          }
        })
        // const subeventArr = subeventList.filter(item => {
        //   return item.segmentId != 15
        // })
        this.subeventList = subeventList
      }
      // 存一下所有事件的时间
      this.AllEventTime.EventStarttime = this.eventDetail.startTime
      this.AllEventTime.SubeventTime = this.SubeventTotalTime()
      this.AllEventTime.EventTime = this.eventDetail.endTime - this.eventDetail.startTime
      this.AllEventTime.VideoTime =
        this.eventDetail.duration - this.AllEventTime.SubeventTime
      this.setSubeventDateLimit()
      if (!this.PreviousAction.eventDetail) {
        // 推送操作
        this.PushUndo('lastStep')
      }
    },
    // 设置子事件选择范围并且转化显示时间
    setSubeventDateLimit () {
      if (this.eventDetail.startTime && this.eventDetail.endTime) {
        // 子事件选择范围
        this.subeventDateLimit =
          `${Outil.changeNewTime(this.eventDetail.startTime)
          } - '23:59:59'`
        // 存一下日期
        this.eventDetail.newdate = Outil.changeNewDate(this.eventDetail.startTime, 1)
        // 初始时间的变化
        const EventTimeChange =
          this.eventDetail.startTime - this.AllEventTime.EventStarttime

        // 修改的上一次时间存一下
        this.AllEventTime.EventStarttime = this.eventDetail.startTime
        let SerialNumber = 0
        this.UnderplayClipList = {}
        // PGMSCTE的信息展示
        const ScteMessage = {
          maxTime: 0,
          TotalTime: 0,
          ScteNumber: 0
        }
        // 转换显示时间
        this.subeventList.forEach((item, index) => {
          if (item.segmentId == 1) {
            SerialNumber++
            item.SerialNumber = SerialNumber
          }
          if ((item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) && item.eventOperationType == 'Underplay Block') {
            if (this.UnderplayClipList[item.blockId]) {
              item.UnderplayClip = 0
              item.blockId && (this.UnderplayClipList[item.blockId] += 1)
            } else {
              item.UnderplayClip = 1
              item.blockId && (this.UnderplayClipList[item.blockId] = 1)
            }
          } else if (item.segmentId == 13 && (item.eventOperationType == 'Flowics' || item.eventOperationType == 'Singular')) {
            if (this.UnderplayClipList[item.blockId]) {
              item.blockId && (this.UnderplayClipList[item.blockId] += 1)
            } else {
              item.blockId && (this.UnderplayClipList[item.blockId] = 1)
            }
          }
          if (EventTimeChange) {
            item.timingIn = item.timingIn + EventTimeChange
            item.timingOut = item.timingOut + EventTimeChange
          }
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
          item.ShowTimingIn = item.timingIn
            ? Outil.changeNewTime(item.timingIn)
            : item.timingIn
          item.ShowTimingOut = item.timingOut
            ? Outil.changeNewTime(item.timingOut)
            : item.timingOut
          item.durationEdit = false
          ScteMessage.maxTime += item.accumulatedProgramTiming
          if (item.segmentId == 2 || item.segmentId == 11 || item.segmentId == 14) {
            ScteMessage.TotalTime += item.accumulatedProgramTiming
            ScteMessage.ScteNumber++
          }
        })
        this.PGMScteMessage.PGMTotalTime = ScteMessage.maxTime > 0 ? Outil.getDuration(ScteMessage.maxTime) : ''
        this.PGMScteMessage.ScteTotalTime = Outil.getDuration(ScteMessage.TotalTime)
        this.PGMScteMessage.ScteNumber = ScteMessage.ScteNumber
        this.countOffset()
        this.subeventList = JSON.parse(JSON.stringify(this.subeventList))
      }
    },
    // 计算子事件的总时间
    SubeventTotalTime () {
      let SubeventTime = 0
      this.subeventList.forEach((item, index) => {
        if (item.segmentId == 2 || item.segmentId == 4) {
          if (item.timingIn && item.timingOut) {
            SubeventTime += item.timingOut - item.timingIn
          }
        }
      })
      this.AllEventTime.SubeventTime = SubeventTime
      return SubeventTime
    },
    changeTimingFile (id) {
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/resolveSegments', {
        fileId: id
        // defaultScteDuration: this.form.scteSpliceDurationDefault
      }, {
        contentType: 'application/json;charset=UTF-8'
      }).then((res) => {
        this.loading = false
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          if (data.eventSegments && data.eventSegments.length > 0) {
            let SerialNumber = 0
            data.eventSegments.forEach((item, index) => {
              if (item.segmentId == 1) {
                SerialNumber++
                item.SerialNumber = SerialNumber
              }
              if (item.segmentId == '2' && !item.eventOperationType) item.eventOperationType = 'Scte only'
              item.accumulatedProgramTiming = (item.timingOut - item.timingIn) * 1000
              if (index == 0) {
                item.timingIn = this.eventDetail.startTime + item.timingIn * 1000
                item.timingOut = item.timingIn + item.accumulatedProgramTiming
              } else {
                item.timingIn = data.eventSegments[index - 1].timingOut
                item.timingOut = item.timingIn + item.accumulatedProgramTiming
              }
            })
            this.DeleteSubeventList = this.subeventList
            this.subeventList = data.eventSegments
            this.SegmentTimeFormat()
            const videoTimes = this.videoTimes * 1000
            if (this.videoTimes) {
              this.FillingTime(videoTimes)
            }
            // 推送操作
            this.PushUndo()
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取objectkey
    async getObjectKey (userId) {
      const param = {
        directory: 'INCOMING',
        userId,
        bucket: this.RegionInfo.bucket
      }
      await this.axios
        .post('/file/get-user-bucket-dir', param, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.FolderObjectKey = res.data.result.objectKey
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    async getMcpList () {
      if (!this.FolderObjectKey) {
        const userId = Outil.getProgramReceiver('ownerUserId')
        await this.getObjectKey(userId)
      }
      const params = {
        isDirectory: false,
        suffixList: ['csv', 'xml'],
        region: this.RegionInfo.region,
        service: this.RegionInfo.ServerName,
        bucketId: this.RegionInfo.bucketId,
        type: 3,
        objectKeyLike: this.FolderObjectKey,
        nameLike: this.McpObj.condition,
        pageIndex: this.McpObj.pageNum,
        pageSize: this.McpObj.pageSize
      }
      this.axios.post('/file/query', params, { requestBase: 'GATEWAY' }).then((res) => {
        if (res.data.errorCode === '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.mcpTimingList = this.mcpTimingList.concat(res.data.result.records)
          } else {
            this.mcpTimingList = res.data.result.records
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    getNextPage () {
      if (this.bindScroll.loading || this.bindScroll.noMore) return
      this.McpObj.pageNum += 1
      this.getMcpList()
    },
    // 搜索timming文件列表
    searchFile (value) {
      this.McpObj.pageNum = 0
      this.McpObj.condition = value
      this.getMcpList()
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    },
    // 展示时间
    displayTime (startTime, endTime, type) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const endDate = Outil.getDateTime(new Date(endTime))
      const startDay =
        `${startDate.year}-${startDate.month}-${startDate.day}`
      const endDay = `${endDate.year}-${endDate.month}-${endDate.day}`
      // type有值不返回日期
      if (type) {
        return `${startDate.hour}:${startDate.min}:${startDate.s} - ${endDate.hour
          }:${endDate.min}:${endDate.s}`
      } else if (startDay == endDay) {
        return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s
            } - ${endDate.hour}:${endDate.min}:${endDate.s}`
      } else {
        return `${startDay} ${startDate.hour}:${startDate.min} - ${endDay} ${endDate.hour
            }:${endDate.min}`
      }
    },
    // SourceType类型改变
    SourceTypeChange () {
      this.eventDetail.fileId = ''
      this.eventDetail.tpeerid = ''
      this.eventDetail.tname = ''
    }
  }
}
</script>

<style scoped lang="less">
.PopupBox {
  // position: fixed;
  // top: 0;
  // left: 0;
  .createBooking {
    position: absolute;
    max-height: 400px;
    background-color: #252525;
    border-radius: 4px;
    z-index: 2000;
    padding: 0.16rem;
    padding-right: 0.2rem;
    color: #999;
    font-size: 0.16rem;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
    .EventWrapTitle {
      margin-bottom: 15px;
      .closeCreateBox {
        position: absolute;
        right: 20px;
        top: 15px;
      }
      .EventTopTitle {
        width: 362px;
        display: flex;
        p {
          margin: 0;
        }
        .event_color {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: none;
        }
        .Event_title {
          width: 332px;
          height: 20px;
          text-align: left;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .CompileTitle {
        display: flex;
      }
      .separator {
        padding: 0 10px;
      }
      li.active {
        color: #33ab4f;
      }
    }
    .EventDetail {
      width: 362px;
      max-height: 283px;
      overflow-y: auto;
      font-size: 12px;
      margin-bottom: 10px;
      .detail_item {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid #444444;
        padding: 0 10px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .detailLeft {
          font-size: 12px;
          color: #666;
          margin: 0;
          text-align: left;
        }
        .detailRight {
          width: 240px;
          height: 100%;
          font-size: 12px;
          color: #dfdfdf;
          margin: 0;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        ::v-deep .el-input__inner {
          border: none;
          color: #dfdfdf;
          font-size: 12px;
          width: 165px;
        }
      }
      .eventsDetail {
        .detailbottom {
          border-bottom: transparent;
        }
        .detail_item {
          i {
            font-size: 15px;
          }
          .el-icon-arrow-up:before {
            content: '\E605';
          }
        }

        .eventsListWrap {
          padding: 0 10px;
          .eventsBox {
            height: 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #dfdfdf;
            div {
              line-height: 14px;
            }
            .title {
              width: 130px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .time {
              width: 110px;
            }
            .duration {
              width: 50px;
              text-align: right;
            }
          }
        }
      }
      .storySlug {
        display: block;
        height: 80px;
        .detailRight {
          width: 100%;
          line-height: 14px;
          text-align: left;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box; /** 将对象作为伸缩盒子模型显示 **/
          -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
          -webkit-line-clamp: 3; /** 显示的行数 **/
        }
      }
    }
    .EventDetail::-webkit-scrollbar-thumb {
      background: #444444;
    }
    .EventUpdateandCreate {
      .note {
        width: 362px;
        .color_box {
          height: 100%;
          padding-right: 22px;
          position: relative;
        }
        .color_opt {
          width: 255px;
          height: 40px;
          background: #333;
          color: #999;
          border-radius: 4px;
          position: absolute;
          right: -11px;
          top: 31px;
          padding: 10px 0;
          padding-left: 6px;
          font-size: 12px;
          line-height: 20px;
          z-index: 10000;
          display: flex;
          ul {
            display: flex;
            li {
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 10px;
            }
          }
        }
        .color {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          margin-top: 4px;
          box-sizing: content-box;
        }
        .el-icon-caret-bottom {
          font-size: 20px;
          position: absolute;
          top: 16%;
          right: 0px;
          transform: translateY(-50%);
          transform: rotate(0deg);
          transition: 0.3s;
        }
        .el-icon-caret-bottom.top {
          transform: rotate(-180deg);
        }

        textarea {
          width: 362px;
          border: none;
          outline: none;
          background: #444;
          border-radius: 4px;
          height: 60px;
          color: #999;
          font-size: 12px;
          line-height: 15.6px;
          padding: 2px 2px 2px 10px;
          box-sizing: border-box;
        }
        .c_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .HouseIDKey{
            color: #999;
            font-size: 14px;
          }
          .HouseIDVaule{
            color: #999;
            font-size: 14px;
            margin-left: 6px;
            input {
              width: 285px;
            }
          }
          input {
            width: 362px;
            height: 30px;
            background-color: #444;
            color: #dbdbdb;
            border: none;
            outline: none;
            border-radius: 4px;
            text-indent: 10px;
            font-size: 12px;
            box-sizing: border-box;
            text-align: left;
          }
        }
        ::v-deep.c_item.des{
          position: relative;
          .desNum{
            position: absolute;
            bottom: 0;
            right: 2px;
            font-size: 12px;
          }
        }
        .DuplicateHint{
          font-size: 12px;
          line-height: 14px;
          color:#FD5454;
          text-align: left;
          padding-left: 10px;
        }
        .timeSelete {
          .time_opt {
            width: 170px;
            height: 30px;
            line-height: 26px;
            color: #000;
            background: rgba(228, 228, 228, 1);
            border: none;
            border-radius: 4px;
            ::v-deep .el-date-editor.el-input {
              width: 100%;
            }
            ::v-deep input.el-input__inner {
              width: 100%;
              height: 30px;
              background: #444;
              padding-left: 10px;
              border: none;
              color: #dfdfdf;
              font-size: 12px;
              padding-right: 0;
            }
            ::v-deep .el-input__prefix,
            .el-input__suffix-inner {
              display: none;
            }
          }
          .to {
            color: #999;
            margin: 0 7px;
            line-height: 30px;
            font-size: 12px;
          }
        }
        ::v-deep .RecordSelete {
          height: 20px;
          margin: 10px 0;
          .is-checked {
            .el-checkbox__inner {
              background: #33ab4f;
            }
            .el-checkbox__inner::after {
              border-color: #fff;
            }
          }

          .el-checkbox__label {
            border-color: #dbdbdb;
          }
        }
      }
      .EventsWrap {
        width: 671px;
        height: 277px;
        ::v-deep .ReferenceMedia {
          margin-bottom: 10px;
          display: flex;
          .MediaType {
            width: 110px;
          }
          .MediaSelect {
            width: 208px;
          }
          .Thumbnails {
            margin-left: 10px;
            input{
              width: 150px;
              height: 30px;
              background-color: #444;
              color: #44A4FD;
              border: none;
              outline: none;
              border-radius: 4px;
              font-size: 12px;
              box-sizing: border-box;
              text-align: left;
              padding: 0 10px;
            }
          }
          .el-input--suffix {
            background: #444444;
            .el-input__inner {
              height: 30px;
              font-size: 12px;
              color: #dbdbdb;
              padding-left: 10px;
            }
          }
          .el-select-dropdown__item {
            font-size: 12px;
            height: 30px;
            padding-left: 10px;
          }
          .el-select__caret {
            color: #999999;
          }
          .el-scrollbar__wrap {
            text-align: left;
            max-width: 240px;
            .el-scrollbar__view {
              width: 100%;
            }
          }
        }
        .EventsTitle {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 2px solid #444444;
          height: 30px;
          font-size: 14px;
          color: #8c8a88;
          .MediaIndex{
            width: 10px;
          }
          .Title-item {
            width: 100px;
            margin-right: 8px;
            text-align: left;
          }
          .Duration {
            margin-right: 0;
          }
        }
        ::v-deep .EventsListWrap {
          height: 217px;
          overflow-y: auto;
          .EventsList {
            height: 40px;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #444444;
            .MediaIndex{
              width: 10px;
              font-size: 12px;
            }
            .Title-item {
              width: 100px;
              margin-right: 8px;
              text-align: left;
              .referenceName{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
                color: #dfdfdf;
              }
              .noSelete {
                font-size: 14px;
                color: #dbdbdb;
              }

              .el-input--suffix {
                background: #444444;
                .el-input__inner {
                  height: 30px;
                  font-size: 12px;
                  color: #dbdbdb;
                  padding-left: 10px;
                  padding-right: 0;
                }
              }
              .el-select-dropdown__item {
                font-size: 12px;
                height: 30px;
                padding-left: 10px;
              }
              .el-select__caret {
                color: #999999;
              }
              .fileSelete {
                .el-popper {
                  max-width: 200px;
                }
                .el-select-dropdown__wrap {
                  max-height: 200px;
                }
                .logoAndHashValue{
                  .el-input__inner{
                    height: 30px;
                    // line-height: 30px;
                    border: 1px solid #444;
                    background: #444;
                  }
                }
                .showRed{
                  .el-input--suffix {
                    .el-input__inner{
                      color: red;
                    }
                  }

                }
              }
              .flowicsContent{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .flowicsSelect{
                  width: 85%;
                }
                .flowicsAdd{
                  width: 10%;
                }
              }
              .logoAndHashText{
                font-size: 12px;
              }
            }
            .timePicker {
              width: 100px;
              position: relative;
              .el-input--suffix {
                width: 100px;
                .el-input__inner {
                  width: 100px;
                  border: 1px solid #353535;
                  background: #444444;
                }
                .el-input__prefix,
                .el-input__suffix {
                  display: none;
                }
              }
              .SecondaryOffset{
                width: 100px;
                height: 30px;
                position: absolute;
                top: 0;
                left: 0;
                background: #444444;
                z-index: 1;
                color: #dbdbdb;
                line-height: 30px;
                font-size: 12px;
                padding-left: 8px;
              }
            }
            .Duration-item {
              margin-right: 0;
              .Duration {
                font-size: 12px;
                color: #dfdfdf;
              }
            }
          }
          .addSubevent {
            text-align: right;
            font-size: 12px;
            color: #cccccc;
            padding-right: 5px;
          }
        }
      }
      .device {
        width: 362px;
        height: 210px;
        color: rgb(102, 102, 102);
        margin: 0 9px;
        .d_item {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border-bottom: 1px solid rgba(153, 153, 153, 1);
          font-size: 12px;
          padding: 0 20px 0 10px;
          display: flex;
          justify-content: space-between;
          .val {
            color: #999;
            width: 56%;
            text-align: right;
            position: relative;
          }
          .ValSelet {
            padding-right: 10px;
            span {
              height: 31px;
              overflow: hidden;
            }
          }
          .ValSelet::before {
            content: '';
            position: absolute;
            top: 60%;
            left: 94%;
            border: 6px solid;
            transform: translateY(-50%);
            border-color: transparent;
            border-top-color: #999;
            transition: 0.3s;
          }
          .ValSelet.up:before {
            top: 23%;
            transform: rotate(-180deg);
          }
          .input {
            float: right;
            height: 25px;
            width: 135px;
            margin-top: 3px;
            margin-right: -20px;
            border: none;
            padding-left: 10px;
            padding-right: 20px;
            box-sizing: border-box;
            color: #999;
            background-color: transparent;
            text-align: right;
            outline: none;
          }
          .scte_ipt {
            color: #000;
          }
          .delay,
          .bitrate {
            text-align: left;
            background-color: #fff;
          }
          ::v-deep .createbox_r_list {
            position: absolute;
            right: 0;
            top: 32px;
            background: #ababab;
            width: 2.2rem;
            height: 170px;
            text-align: left;
            .infinite-list {
              height: 170px;
            }
            li {
              padding-left: 10px;
              height: 32px;
              line-height: 32px;
              box-sizing: border-box;
              font-size: 12px;
              color: #666;
            }
            li:hover {
              background: rgba(0, 208, 105, 0.2);
            }
            .el-scrollbar__thumb {
              background: #fff;
            }
          }
        }
        .d_item.source {
          input {
            float: right;
            border: none;
            height: 25px;
            width: 100px;
            padding-left: 10px;
            padding-right: 25px;
            margin-right: -20px;
            margin-top: 3px;
            box-sizing: content-box;
            color: #000;
          }
        }
      }
    }
    ::v-deep #EventUpdateandCreate {
      pointer-events: none;
      input,
      textarea,
      span {
        background: #252525;
        border: 1px solid #353535;
        color: #666666;
      }
    }
    .create_footer {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      .DetailButton {
        width: 147px;
        display: flex;
        justify-content: space-between;
        margin-right: 50px;
      }
      button {
        width: 75px;
        height: 30px;
        background: #999;
        color: #fff;
        border: none;
        border-radius: 4px;
        font-size: 12px;
      }
      .ComplieButton {
        width: 155px;
        display: flex;
        justify-content: flex-end;
      }
      .save,
      .edit {
        background-color: #0c6;
        margin-left: 16px;
      }
      .delete {
        width: 56px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid rgba(153, 153, 153, 1);
        background: transparent;
      }
      .copy {
        color: #39aa50;
        border: 1px solid #39aa50;
        background: transparent;
      }
      .end_live {
        background: #f00;
        color: #fff;
      }
    }
  }
  .createBooking::before {
    content: '';
    border: 12px solid transparent;
    border-top-color: #252525;
    border-right-color: #252525;
    position: absolute;
    left: 60px;
    top: -10px;
    box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
    transform: rotate(-45deg);
  }
  .createBookingRight {
    transform: translateX(-100%);
    // margin-left: -100%;
  }
  .createBookingBottom {
    transform: translateY(-100%);
  }
  .createBookingRightBottom {
    transform: translate(-100%, -100%);
  }
  .createBookingRight::before {
    left: 100%;
    transform: rotate(-45deg);
    margin-left: -100px;
  }
  .createBookingBottom::before {
    top: 100%;
    transform: rotate(135deg);
    margin-top: -15px;
  }
  // .createBookingRightBottom::before {
  //   left: 100%;
  //   top: 100%;
  //   transform: rotate(135deg) translateX(-20px);
  // }

  .green {
    border: 1px solid #0a9a5a;
    background: #0fbe71;
  }
  .skyblue {
    background-color: #46c9e1;
    border: 1px solid #0ca595;
  }
  .blue {
    background-color: rgb(14,107,209);
    border: 1px solid #126ed3;
  }
  .orange {
    background-color: #ffc573;
    border: 1px solid #d8a966;
  }
  .pink {
    background-color: #ff6a92;
    border: 1px solid #ee3656;
  }
  .yellow {
    background-color: #ffc000;
    border: 1px solid #ffc000;
  }
  .purple {
    background-color: #9248c7;
    border: 1px solid #9248c7;
  }
}
</style>
